import React from 'react';
import TextInput from '../../form/TextInput';
import Select from '../../form/Select';
import createForm from "./Form";
import Tags from "../../form/Tags";
import {loadComponentById} from "../../../utils/components";
import {get} from "../../../utils/dotutils";
import {ChildFragmentEditor} from "../FragmentEditor";
import FigureEditor from "../figureEditor";
import strip_tags from "locutus/php/strings/strip_tags";
import Tabs from "../../layout/Tabs";
import TabContent from "../../layout/TabContent";
import ComponentLoader from "../../form/ComponentLoader";
import classNames from "classnames";
import {importFromMustache} from "../../form/editor/slate/replacement/Mustache";
import MustacheElements from "../../form/editor/plugins/replacement/Mustache";

class Variable extends React.Component {

    state = {
        data: undefined
    }

    constructor(props) {
        super(props);
        this.loadData();
    }


    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.component_type + "_" + this.props.component_id + "_" + this.props.field !== prevProps.component_type + "_" + prevProps.component_id + "_" + prevProps.field) {
            this.loadData();
        }
    }

    loadData = () => {
        if (this.props.component_type && this.props.component_id) {
            this.loadDataRequest && this.loadDataRequest.abort();
            const field = this.props.field;
            this.loadDataRequest = loadComponentById(this.props.component_type, this.props.component_id, [field]);
            this.loadDataRequest.then((component) => {
                this.setState({data: get(component, field, undefined)});
            })
        } else {
            this.setState({data: undefined});
        }
    }

    render() {
        return strip_tags(this.state.data !== undefined ? this.state.data : this.props.field);
    }
}

class MustacheReplaced extends React.Component {
    render() {
        const value = this.props.values[this.props.field] || get(this.props.componentConfig, "config.defaults." + get(this.props.componentConfig, "config.componentAliases." + this.props.values.component_type, this.props.values.component_type) + "." + this.props.field);
        return (value || "").split(/([\{][\{][^\}]+[\}][\}])/g).map((s) => {
            if (/{{[^}]+}}/g.test(s)) {
                const variable = s.substring(2, s.length-2);
                return <Variable {...this.props} component_type={this.props.values.component_type} component_id={this.props.values.component_id} field={variable} />;
            } else {
                return s;
            }
        });
    }
}

const nodes = (node, component_type, component_id) => {
    let texts = [];
    if (!node) {
        return [];
    }
    if (node.type === "variable") {
        texts.push(new Promise((resolve) => {
            const field = node.props.variable;
            loadComponentById(component_type, component_id, [field]).then((component) => {
                resolve((get(component, field) || "").length);
            })
        }));
    } else {
        if (node.children) {
            node.children.map((node) => {
                texts = [...texts, ...nodes(node, component_type, component_id)];
            })
        } else if (node.text) {
            texts.push(new Promise((resolve) => resolve(node.text.length)));
        }
    }
    return texts;
}

class SeoForm extends React.Component {

    state = {
        descriptionLength: 0
    }

    getValue = (field) => {
        return get(this.props.values, field, get(this.props.componentConfig, "config.defaults." + get(this.props.componentConfig, "config.componentAliases." + this.props.values.component_type, this.props.values.component_type) + "." + field));
    }

    constructor(props) {
        super(props);
        this.descriptionLength();
    }


    componentDidUpdate(prevProps, prevState, snapshot) {
        if (
            this.props.values.description !== prevProps.values.description
            ||
            this.props.values.component_type !== prevProps.values.component_type
            ||
            this.props.values.component_id !== prevProps.values.component_id
        ) {
            this.descriptionLength();
        }
    }

    descriptionLength = () => {
        Promise.all(nodes(importFromMustache(this.props.values.description, MustacheElements).children, this.props.values.component_type, this.props.values.component_id)).then((lengths) => {
            this.setState({
                descriptionLength: lengths.reduce((sum, length) => sum + length, 0)
            })
        });
    }

    render() {

        const figure = get(this.props.componentConfig, "config.defaults." + get(this.props.componentConfig, "config.componentAliases." + this.props.values.component_type, this.props.values.component_type) + ".figure");

        //console.log(this.props.values.title);
        //console.log(this.props.values.description);

        return (
            <form onSubmit={this.props.handleSubmit} className="seo-form">
                <div className="row form-row">
                    <div className="col-sm-12">
                        <div className="form-group">
                            <Tags
                                name="title"
                                oneLine={true}
                                value={this.props.values.title}
                                label="Cím"
                                component={this.props.values.component_type}
                                componentId={this.props.values.component_id}
                                saveChanges={this.props.setFieldValue}
                                {...this.props.getFieldProps("title")}
                            />
                        </div>
                    </div>
                    <div className="col-sm-12">
                        <div className="form-group">
                            <label className="control-label">Előnézet</label>
                            <div className="title-style">
                                <span><MustacheReplaced
                                    {...this.props}
                                    field="title"
                                /></span>
                            </div>
                        </div>
                    </div>
                </div>
                {!this.props.presets.component_type && <div className="row form-row">
                    <div className="col-md-6">
                        <Select
                            storeType="remote"
                            component="ComponentConfig"
                            objectValue={false}
                            valueKey="name"
                            labelKey="name"
                            name="component_type"
                            value={this.props.values.component_type}
                            label="Komponens"
                            saveChanges={this.props.setFieldValue}
                            {...this.props.getFieldProps("component_type")}
                        />
                    </div>
                    <div className="col-md-6">
                        <TextInput
                            name="component_id"
                            value={this.props.values.component_id}
                            label="Id"
                            saveChanges={this.props.setFieldValue}
                            {...this.props.getFieldProps("component_id")}
                        />
                    </div>
                </div>}
                <div className="row form-row">
                    <div className="col-md-12">
                        <div className="form-group">
                            <Tags
                                name="description"
                                value={this.props.values.description}
                                label="Leírás"
                                height="200px"
                                component={this.props.values.component_type}
                                componentId={this.props.values.component_id}
                                saveChanges={this.props.setFieldValue}
                                {...this.props.getFieldProps("description")}
                            />
                        </div>
                        <span className="pull-right label label-default">{255 - (this.state.descriptionLength || 0)} Karakter van hátra</span>
                        <div className="description-style">
                            <label className="control-label">Előnézet</label>
                            <div>
                                <MustacheReplaced
                                    {...this.props}
                                    field="description"
                                />
                            </div>
                        </div>
                        {/*<span className="pull-right label label-default">{255 - (this.props.values.description || "").length} Karakter van hátra</span>
                        <div className="clearfix" />*/}
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-md-12">
                        <div className="form-group">
                            <TextInput
                                name="keywords"
                                value={this.props.values.keywords}
                                label="Kulcsszavak"
                                saveChanges={this.props.setFieldValue}
                                {...this.props.getFieldProps("keywords")}
                            />
                        </div>
                        <span className="pull-right label label-default">{255 - (this.props.values.keywords || "").length} Karakter van hátra</span>
                        <span className="help-block">Érdemes vesszővel, szóközök nélkül elválasztott szavakat megadni.</span>
                        <div className="clearfix" />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-md-12">
                        <label className="control-label">Borító kép</label>
                        <FigureEditor
                            component={this.props.values.component_type}
                            componentId={this.props.values.component_id}
                            list={ChildFragmentEditor}
                            editor={() => <div/>}
                            selection={this.props.values.figure}
                            values={{}}
                            loadForm={(img) => this.props.setFieldValue("figure", img)}
                            isLoading={this.props.disabled}
                            pageSize={0}
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-md-12">
                        <div className="form-group">
                            <Select
                                name="og_type"
                                isClearable={true}
                                objectValue={false}
                                optionname="og_type"
                                storeType="local"
                                saveChanges={this.props.setFieldValue}
                                value={this.getValue('og_type')}
                                label="Megjelenítési/tartalmi stílus"
                            />
                        </div>
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-md-12">
                        <div className="form-group">
                            <Select
                                name="twitter_style"
                                isClearable={true}
                                objectValue={false}
                                optionname="twitter_style"
                                storeType="local"
                                saveChanges={this.props.setFieldValue}
                                value={this.getValue('twitter_style')}
                                label="Twitter stílusa"
                            />
                        </div>
                    </div>
                </div>
                <Tabs
                    theme="default"
                    defaultTab="facebook-preview"
                >
                    <TabContent
                        tabLabel="Facebook előnézet"
                        tabName="facebook-preview"
                    >
                        <div className={classNames("facebook-preview", this.getValue('og_type'))}>
                            <div className="post">
                                <div className="profile">
                                    <div className="profile-image" />
                                    <div className="profile-name">{window.location.hostname}</div>
                                    <div className="time">2 ó</div>
                                </div>
                                {!!this.props.values.figure ? <div className="image" style={{backgroundImage: "url('" + this.props.values.figure.url + "')"}} /> : (isNaN(figure) ? <ComponentLoader componentName={this.props.values.component_type} componentId={this.props.values.component_id} view={[figure]}>
                                    {(props) => !!get(props.values, figure) && <div className="image" style={{backgroundImage: "url('" + get(props.values, figure).url + "')"}} />}
                                </ComponentLoader> : <ComponentLoader componentName="figure" componentId={figure} onFailure={Fragment}>
                                    {(props) => <div className="image" style={{backgroundImage: "url('" + props.values.url + "')"}} />}
                                </ComponentLoader>)}
                                <div className="data-container">
                                    <div className="data">
                                        <div className="hostname">{window.location.hostname}</div>
                                        <div className="title"><MustacheReplaced
                                            {...this.props}
                                            field="title"
                                        /></div>
                                        <div className="description"><MustacheReplaced
                                            {...this.props}
                                            field="description"
                                        /></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <a href="https://developers.facebook.com/tools/debug/" target="_blank">Facebook debug</a>
                    </TabContent>
                    <TabContent
                        tabLabel="Twitter előnézet"
                        tabName="twitter-preview"
                    >
                        <div className={classNames("twitter-preview", this.getValue('twitter_style'))}>
                            <div className="post">
                                <div className="profile">
                                    <div className="profile-image" />
                                    <div className="profile-name">{window.location.hostname}</div>
                                    <div className="profile-nick">@{window.location.hostname}</div>
                                </div>
                                <div className="data-container">
                                    {!!this.props.values.figure ? <div className="image" style={{backgroundImage: "url('" + this.props.values.figure.url + "')"}} /> : (isNaN(figure) ? <ComponentLoader componentName={this.props.values.component_type} componentId={this.props.values.component_id} view={[figure]}>
                                        {(props) => !!get(props.values, figure) && <div className="image" style={{backgroundImage: "url('" + get(props.values, figure).url + "')"}} />}
                                    </ComponentLoader> : <ComponentLoader componentName="figure" componentId={figure} onFailure={Fragment}>
                                        {(props) => <div className="image" style={{backgroundImage: "url('" + props.values.url + "')"}} />}
                                    </ComponentLoader>)}
                                    <div className="data">
                                        <div className="title"><MustacheReplaced
                                            {...this.props}
                                            field="title"
                                        /></div>
                                        <div className="description"><MustacheReplaced
                                            {...this.props}
                                            field="description"
                                        /></div>
                                        <div className="hostname">{window.location.hostname}</div>
                                    </div>
                                </div>
                                <div className="time">6:49 PM · Feb 22, 2016</div>
                            </div>
                        </div>
                        <a href="https://developer.twitter.com/en/docs/twitter-for-websites/cards/overview/abouts-cards" target="_blank">Twitter infó link</a>
                    </TabContent>
                </Tabs>
            </form>
        );
    }
}

export default createForm(SeoForm);
